import * as React from 'react';

import SubscriptionTiersEnrollButton from 'bundles/coursera-plus/components/subscriptionTiers/SubscriptionTiersEnrollButton';
import type { PropsFromCaller as EnrollButtonProps } from 'bundles/coursera-plus/components/subscriptionTiers/SubscriptionTiersEnrollButton';
import type { SubscriptionTiersProductVariant } from 'bundles/coursera-plus/constants/CourseraPlusProductVariant';
import { courseraPlusProductVariants } from 'bundles/coursera-plus/constants/CourseraPlusProductVariant';
import EnrollmentChoiceTypes from 'bundles/enroll-course/common/EnrollmentChoiceTypes';
import {
  choiceTypeToHandleSubmitPromise,
  submitEnrollmentPromise,
} from 'bundles/enroll-course/lib/enrollmentChoiceUtils';

export type PropsToComponent = Omit<EnrollButtonProps, 'onCtaClick'> & {
  productItemId?: SubscriptionTiersProductVariant;
};

export const handleCreateCourseraPlusCart = (productItemId: SubscriptionTiersProductVariant) => {
  const handleSubmitPromise = choiceTypeToHandleSubmitPromise[EnrollmentChoiceTypes.SUBSCRIBE_TO_COURSERA_PLUS];
  return submitEnrollmentPromise({
    handleSubmitPromise,
    options: { productItemId, isSubscriptionOnly: true },
  });
};

const AllPlansCourseraPlusEnrollButton = ({
  productItemId = courseraPlusProductVariants.MONTHLY_WITH_FREE_TRIAL,
  ...props
}: PropsToComponent) => {
  return <SubscriptionTiersEnrollButton onCtaClick={() => handleCreateCourseraPlusCart(productItemId)} {...props} />;
};

export default AllPlansCourseraPlusEnrollButton;
